<template>
    <div class ="farmacia-entradas-container">
        <v-card>
            <v-card-title>
                <h3> Existencia de medicamentos</h3>
                <v-spacer></v-spacer>
                <v-btn color ="success" @click="cargarYExportarExcel" :loading="loading">
                    <v-icon left>mdi-file-excel</v-icon>
                    Descargar Excel
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-alert type="info" class="mt-4">
                    Haga click en el boton "Descargar Excel" para obtener el reporte completo de Existencia de medicamentos
                </v-alert>
            </v-card-text>
         </v-card> 
    </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
    name: 'FarmaciaEntradas',
    data() {
        return {
            loading: false,
            entradas: [],
            headers: [
                {text: 'Fecha Entrada', value: 'fechaEntrada'},
                {text: 'Entrada ID', value: 'entradaId'},
                {text: 'Origen', value: 'origen'},
                {text: 'Proveedor', value: 'proovedor'},
                {text: 'Clave', value: 'clave'},
                {text: 'Concepto', value: 'concepto'},
                {text: 'Especificaciones', value: 'especificacion'},
                {text: 'Medida', value: 'medida'},
                {text: 'Tipo Insumo', value: 'tipoInsumo'},
                {text: 'Lote', value: 'lote'},
                {text: 'Caducidad', value: 'caducidad'},
                {text: 'Precio', value: 'precio'},
                {text: 'Disponible', value: 'disponible'},
                {text: 'Existencia Actual', value: 'existenciaActual'},
                {text: 'Minimo', value: 'minimo'},
                {text: 'Maximo', value: 'maximo'},
                {text: 'Optimo', value: 'optimo'},
                {text: 'Disponibilidad', value: 'disponibilidad'},
                {text: 'Observaciones Entrada', value: 'observacionesEntrada'},
                {text: 'Observaciones Lote', value: 'loteObservaciones'},
                {text: 'Observaciones Medicamentos', value: 'medicamentosObservaciones'}
            ]
        }
    },
    computed: {
        puedeDescargarExcel() {
            const roles = this.$store?.state?.security?.roles || []
            const username = this.$store?.state?.security?.username || ''
            const rolesPermitidos = [
                'ROLE_EXISTENCIAS'
            ]
            console.log('=== DEBUG PERMISOS ===')
            console.log('Usuario logueado:', username)
            console.log('Roles del usuario:', roles)
            console.log('Roles permitidos:', rolesPermitidos)
            console.log('Tipo de roles:', typeof roles, Array.isArray(roles))
            
            const tienePermiso = roles.some(role => rolesPermitidos.includes(role))
            console.log('Tiene permiso:', tienePermiso)
            console.log('======================')
            return tienePermiso
        }
    },
    methods: {
        async cargarYExportarExcel() {
            console.log('Verificando permisos...')
            if (!this.puedeDescargarExcel) {
                alert('No tienes permiso para descargar el Excel')
                console.log('Permiso denegado')
                return
            }
            console.log('Permiso concedido')
            this.loading = true
            try {
                const response = await this.$http({
                    method: 'GET',
                    url: '/farmacia/obtenerEntradasFarmacia'
                })

                let datos = []
                if (response.data.root) {
                    datos = response.data.root
                } else if (Array.isArray(response.data)) {
                    datos = response.data
                }

                if (datos.length === 0) {
                    alert('No hay datos para exportar')
                    return
                }

                this.exportarExcel(datos)
            } catch (error) {
                console.error('Error al cargar las entradas:', error)
                this.$store.dispatch('security/revisaError', error)
                alert('Error al cargar los datos:' + error.message)
            } finally {
                this.loading = false
            }
        },
        formatDate(date) {
            if (!date) return ''
            const d = new Date(date)
            return d.toLocaleDateString('es-ES')
        },
        formatCurrency(value) {
            if (!value) return '0.00'
            return parseFloat(value).toFixed(2)
        },
        exportarExcel(datos) {
            const datosExportar = datos.map(item => ({
                'Fecha Entrada': this.formatDate(item.fechaEntrada),
                'Entrada ID': item.entradaId,
                'ID Medicamento': item.medicamentoId,
                'Origen': item.origen,
                'Proveedor': item.proovedor,
                'Clave': item.clave,
                'Concepto': item.concepto,
                'Especificacion': item.especificacion,
                'Medida': item.medida,
                'Tipo Insumo': item.tipoInsumo,
                'Lote': item.lote,
                'Caducidad': this.formatDate(item.caducidad),
                'Precio': item.precio ? parseFloat(item.precio).toFixed(2) : '0.00',
                'Disponible': item.disponible,
                'Existencia Actual': item.existenciaActual,
                'Minimo': item.minimo,
                'Maximo': item.maximo,
                'Optimo': item.optimo,
                'Disponibilidad': item.disponibilidad,
                'Ultima Entrada': this.formatDate(item.ultimaEntrada),
                'Ultima Salida': this.formatDate(item.ultimaSalida),
                'Observaciones Entrada': item.observacionesEntrada,
                'Observaciones Lote': item.loteObservaciones,
                'Observaciones Medicamento': item.medicamentosObservaciones
            }))
            // hoja de trabajo excel
            const ws = XLSX.utils.json_to_sheet(datosExportar)

            // crear libro de trabajo
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Existencias medicamentos')
            // generar nombre de archivo con fecha
            const fecha = new Date().toISOString().split('T')[0]
            const nombreArchivo = `Existencias_medicamentos_${fecha}.xlsx`

            // Descargar archivo
            XLSX.writeFile(wb, nombreArchivo)
        }
    }
}
</script>
<style scoped>
.farmacia-entradas-container{
    padding: 20px;
}
</style>